import React from 'react';
import { CardContent, Stack, Alert, AlertTitle } from '@mui/material';
import { IdentificationSection, FacilitySection, ScheduleSection, NotesSection } from './sections';

/**
 * ComplianceCreateForm - Main form container for compliance item creation
 * Organizes all sections in a logical flow
 */
export const ComplianceCreateForm: React.FC = () => {
  return (
    <CardContent sx={{ p: 3, backgroundColor: '#ffffff' }}>
      <Stack spacing={2.5}>
        <FacilitySection />
        <IdentificationSection />
        <ScheduleSection />
        <NotesSection />

        {/* No upload control until the item has been saved once and has an id */}
        <Alert
          severity="info"
          sx={{
            backgroundColor: '#f0f9ff',
            border: '1px solid #bae6fd',
            borderRadius: 1.5,
            '& .MuiAlert-icon': {
              color: '#0284c7'
            }
          }}
        >
          <AlertTitle sx={{ fontWeight: 600, color: '#0f172a' }}>
            Documents
          </AlertTitle>
          Documents can be added after saving this compliance requirement.
        </Alert>
      </Stack>
    </CardContent>
  );
};

export default ComplianceCreateForm;
